<template lang="pug">
section.call-for-action.home-section(v-if="!logged")
  .backdrop(v-image="'/img/about.mission.webp'")
  .container.framed
    .overlay
      h2 Make Pod your
        br
        | distribution solution.
      nuxt-link.el-button.el-button--primary(:to="{ name: 'register' }") Start with us
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      logged: 'authentication/logged'
    })
  }
}
</script>

<style lang="scss" scoped>
section.call-for-action {
  position: relative;
  background: $--color-dark-background;
  color: white;
  padding: 3.5em 0;
  @include media(md) {
    padding: 7em 0;
  }
  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg, transparent, $--color-dark-background);
    @include media(md) {
      background: linear-gradient(90deg, transparent, $--color-dark-background);
      top: 0;
      bottom: 0;
      right: 45%;
      width: 30%;
      height: 100%;
    }
  }
  .backdrop {
    position: absolute;
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    @include media(md) {
      top: 0;
      left: 0;
      bottom: 0;
      height: 100%;
      width: 55%;
    }
  }
  .overlay {
    margin-left: auto;
    position: relative;
    z-index: 1;
    text-align: center;
    @include media(md) {
      text-align: left;
      max-width: 360px;
    }
    h2 {
      font-size: 2em;
    }
  }
}
</style>
